import axios from 'axios';
import router from '../router';
import {  getToken } from '@/utils/auth'

import { Message} from 'element-ui'
const toLogin = () => {
	router.replace({
		path: '/login'
	});
}
// 基本配置
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 根据实际情况修改API地址
  timeout: 10000 // 设置超时时间，单位为ms
});
// 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// 请求拦截器
instance.interceptors.request.use(
  config => {
    config.headers['token'] = getToken('token')?  getToken('token'):''              // 设置请求头部分，这里举例使用了localStorage存储的token作为身份标识
    return config;
  },
  error => {
    return Promise.reject(error);
  });

// 响应拦截器
instance.interceptors.response.use(
  //请求成功
  response => {
    const res = response.data;
    if (res.code == 1) {
      return res
    } else {
      Message.error(res.msg)
      return res
    }
  },
  //请求失败
  error => {
    const {
      response
    } = error;
    if (response) {
      // 请求已发出，但是不在30分钟的范围
      errorHandle(response.status, response.data.message);
       
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
    }
  }
)
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
      case 401:
      toLogin();
      break;
    // 404请求不存在
      case 404:
      // tip('请求的资源不存在');

      break;
  }
}
export default instance;
